import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT, TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import {
  buildPlannedActivityAdminLogFieldChangeRows,
  IPlannedActivityAdminLogFieldChangeRow,
} from 'src/app/crew-management-user/functions/build-planned-activity-admin-log-field-change-rows';
import { IPlannedActivityAdminLogTableRow } from 'src/app/crew-management-user/models/planned-activities/planned-activity-admin-log.model';
import { LogActionLabelDescription, LogActionLabels } from 'src/app/shared/enums/log-action.enum';

@Component({
  selector: 'app-planned-activity-admin-log-template',
  templateUrl: './planned-activity-admin-log-template.component.html',
  styleUrls: ['./planned-activity-admin-log-template.component.scss'],
  standalone: false,
})
export class PlannedActivityAdminLogTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: IPlannedActivityAdminLogTableRow;

  logActionLabels: typeof LogActionLabels = LogActionLabels;
  logActionLabelDescription: Record<string, string> = LogActionLabelDescription;
  timeFormat = TIME_FORMAT;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  fieldChangeRows: IPlannedActivityAdminLogFieldChangeRow[] = [];

  ngOnInit(): void {
    this.fieldChangeRows = buildPlannedActivityAdminLogFieldChangeRows(
      this.element?.fieldsChanged ?? [],
      this.element?.action
    );
  }

  getActionLabelDescriptionKey(): string {
    return this.logActionLabelDescription[this.element?.action] ?? '';
  }

  isDateField(fieldName?: string): boolean {
    return fieldName === 'from' || fieldName === 'to';
  }
}
